/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { useHistory, useParams } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import axios from "axios";

import "./global/global.css";
import GuestReportCard from "./global/components/GuestReportCard";
import Button from "./global/components/Button";
import Logo from "./assets/FastRealtyLogo.png";
import BackIcon from "./assets/Larrow.png";
import Tick from "./assets/check.png";
import PlaidLogo from "./assets/plaid.png";
import ButtonArrow from "./assets/buttonArrow.png";

import {
  addGuestLinkedAccount,
  buildGuestReportRequest,
} from "../../actions/addLinkedAccounts";

const GuestReport = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [showPlaid, setShowPlaid] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [stepperWrapperClass, setStepperWrapperClass] =
    useState("stepper-wrapper");
  const [isReportOnProcess, setIsReportOnProcess] = useState(false);

  const [linkToken, setLinkToken] = useState(null);
  const [newAccountStep, setNewAccountStep] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const [acceptedEula, setAcceptedEula] = useState(false);
  const [showChecklist, setShowChecklist] = useState(true);
  const [plaidLinked, setPlaidLinked] = useState(false);
  const [reportNotFound, setReportNotFound] = useState(false);
  const [reportAlreadyStarted, setReportAlreadyStarted] = useState(false);
  const [reportInProgress, setReportInProgress] = useState(false);
  const [reportComplete, setReportComplete] = useState(false);
  const [reportRequestError, setReportRequestError] = useState(false);

  const {
    apiReportRequestSuccess,
    apiReportRequestFail,
    guestData,
    guestDataLoading,
  } = useSelector((state) => state);

  const { id, pin } = useParams();
  console.log("id:", id);
  console.log("pin:", pin);

  const onSuccess = useCallback(
    (token, metadata) => {
      dispatch(addGuestLinkedAccount(token, metadata, id, pin));
      setPlaidLinked(true);
      setShowPlaid(false)
      handleReportNext();
      setShowChecklist(true);
    },
    [dispatch]
  );
  useEffect(async () => {
    try {
      const params = {
        request_id: id,
        request_pin: pin,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/guest/create_link_token`,
        params,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response***", response);

      if (!response.data.status_message) {
        console.log(`guest link token: ${response.data.link_token}`);
        setLinkToken(response.data.link_token);
      } else {
        if (response.data.status_message.includes("in progress")) {
          setStepperWrapperClass("stepper-wrapper opacity");
          setReportAlreadyStarted(true);
          setIsReportOnProcess(true);
        } else {
          setReportNotFound(true);
        }
      }
    } catch (error) {
      // todo --- undo this for testing real report
      if (
        error &&
        error.response &&
        error.response.status === 500 &&
        error.response.data.startsWith("DoesNotExist")
      ) {
        console.log("Requested report not found.");
        setReportNotFound(true);
      }
    }
  }, [setLinkToken]);

  useEffect(() => {
    if (apiReportRequestSuccess) {
      setReportInProgress(true);
      setReportRequestError(false);
    }
  }, [apiReportRequestSuccess]);

  useEffect(() => {
    if (apiReportRequestFail) {
      setReportRequestError(true);
    }
  }, [apiReportRequestFail]);

  useEffect(() => {
    console.log("guestdata", guestData);
    if (guestData && guestData.proof_amount) {
      buildReport();
    }
  }, [guestData]);

  const config = {
    token: linkToken !== null ? linkToken : "",
    onSuccess,
  };

  const { open, ready, err } = usePlaidLink(config);

  useEffect(() => {
    if (plaidLinked === true) {
      setCurrentStep(3);
    }
  }, [plaidLinked]);

  const handlePlaidClick = () => {
    if (ready) {
      open();
    }
  };

  const handleCancelClick = () => {
    setShowChecklist(true);
    // setNewAccountStep(0);
  };

  const handleEulaClick = (event) => {
    setAcceptedEula(event.target.checked);
  };

  const handleEulaNext = (event) => {
    setNewAccountStep((step) => step + 1);
    setShowChecklist(true);
  };
  const handleEulaBack = (event) => {
    setShowChecklist(true);
  };

  const handleGoToEula = () => {
    setShowChecklist(false);
    if (newAccountStep !== 0) {
      setNewAccountStep(0);
    }
  };

  const handleGoToPlaidSetup = () => {
    if (acceptedEula && newAccountStep === 0) {
      // accepted then clicked back
      setNewAccountStep((step) => step + 1);
      setShowChecklist(false);
    }
    setShowChecklist(false);
  };

  const handleGoToCompleteReport = () => {
    setShowChecklist(false);
    // todo update to go to report view page
    history.push(`/sendreport/guest/${id}/${pin}`);
  };

  const handleReportNext = (event) => {
    setNewAccountStep((step) => step + 1);
    setShowChecklist(true);
  };

  const buildReport = useCallback(() => {
    console.log("report building in progress");

    let reportData = {
      request_id: id,
      request_pin: pin,
    };
    dispatch(buildGuestReportRequest(reportData));
  }, [dispatch]);

  const stepClasses = (step) => {
    if (step < currentStep) return "step-icon completed";
    if (step === currentStep) return "step-icon active";
    return "step-icon";
  };
  const connectorClasses = (step) => {
    return step < currentStep ? "step-connector green" : "step-connector";
  };
  const handleCheckboxChange = (e) => setIsChecked(e.target.checked);
  const handleViewAndAcceptClick = () => {
    if (isReportOnProcess) {
      setShowAgreement(false);
    } else {
      setShowAgreement(true);
    }
  };
  const handleProceedBtn = () => {
    setShowAgreement(false);
    setCurrentStep(2);
  };
  const handleAgrrementBackButton = () => {
    setShowAgreement(false);
    setShowPlaid(false);
  };
  const handleProceedToPlaid = () => {
    setShowPlaid(true);
  };

  let completeData;
  if (isChecked) {
    completeData = "Report Building Underway";
  } else if (plaidLinked) {
    completeData = " Report Complete!";
  } else {
    completeData = "Complete Your Report";
  }

  return (
    <div className="guestReport-root">
      <div className="header-logo heading">
        <img
          src={Logo}
          alt="logo"
          className="h-logo full-logo"
          style={{ cursor: "pointer" }}
        />
      </div>

      {/* Main Page */}
      {!showAgreement && !showPlaid && (
        <>
          <div className="header-text">
            <div className="header-text-box">
              <h3>Trust the Fast Realty Process</h3>
              <p>Proof of Funds | Made simple and secure</p>
            </div>
          </div>

          {reportAlreadyStarted && (
            <p className="report-line">
              Report already in progress. Thank you!
            </p>
          )}

          <div className={stepperWrapperClass}>
            <div className="stepper-line">
              {[1, 2, 3].map((step, idx) => (
                <React.Fragment key={step}>
                  <div className={stepClasses(step)}>
                    {stepClasses(step).includes("completed") && (
                      <img src={Tick} alt="tick" className="tick" />
                    )}
                  </div>
                  {step < 3 && <div className={connectorClasses(step)} />}
                </React.Fragment>
              ))}
            </div>

            <div className="stepper-container">
              <GuestReportCard
                heading="Accept Legal Closure"
                subHeading="Fast realty is guaranteed to protect your privacy. Review & accept the legal closure to protect your privacy."
                linkTxt="View & accept"
                isActive={currentStep === 1}
                onLinkClick={handleViewAndAcceptClick}
                isCompleted={!isChecked}
                isChecked={isChecked}
              />
              <GuestReportCard
                heading="Link Accounts Via Plaid"
                subHeading="With Plaid, you can securely connect your bank account to Fast realty in seconds."
                linkTxt="Proceed to Plaid"
                isActive={currentStep === 2}
                onLinkClick={handleProceedToPlaid}
                isCompleted={!plaidLinked && isChecked}
              />
              <GuestReportCard
                heading={completeData}
                subHeading="Check your email for link when it's ready."
                isActive={currentStep === 3}
                linkTxt=" "
              />
            </div>
          </div>
        </>
      )}

      {/* Temrs & Conditions Page */}
      {showAgreement && (
        <>
          <div className="left-arrow-icon">
            <img
              src={BackIcon}
              alt="backIcon"
              className="back-icon"
              onClick={handleAgrrementBackButton}
            />
          </div>
          <div className="header-text">
            <div className="header-text-box">
              <h3>Fast Realty License Agreement</h3>
              <p className="h-bp">
                By proceeding, you acknowledge that you have read and agree to
                the above terms.
              </p>
            </div>
          </div>

          <div className="agreement-alignment-box">
            <div className="agreement-box">
              <div className="agreement-content-box">
                <div className="agreement-contents">
                  {[...Array(2)].map((_, i) => (
                    <React.Fragment key={i}>
                      <p>
                        By submitting a Proof of Funds (POF) document, you agree
                        that all information provided is accurate, current, and
                        verifiable. The document should clearly display your
                        name, issuing institution, and available balance or
                        relevant financial capacity to support the intended
                        booking.
                      </p>
                      <p>
                        All submitted documents will be treated with strict
                        confidentiality and used solely to assess eligibility.
                        We do not store POF documents beyond the verification
                        process.
                      </p>
                      <p>
                        Submission of falsified or misleading documents may
                        result in cancellation or removal. We reserve the right
                        to deny service if the documents are insufficient or
                        unverifiable.
                      </p>
                      <p>
                        By submitting a Proof of Funds (POF) document, you agree
                        that all information provided is accurate, current, and
                        verifiable. The document should clearly display your
                        name, issuing institution, and available balance or
                        relevant financial capacity to support the intended
                        booking. Acceptable documents include recent bank
                        statements, investment summaries, or verified letters
                        from financial institutions.
                      </p>
                    </React.Fragment>
                  ))}
                </div>
              </div>

              <div className="agreement-checkbox">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="acceptTerms" className="checkbox-text">
                  I accept these terms
                </label>
              </div>
            </div>

            <div className="agreement-button">
              <Button
                title="PROCEED"
                txtColor="white"
                bgColor="#28A382"
                disabled={!isChecked}
                borderColor="1px solid #28A382"
                onClickFunc={handleProceedBtn}
              />
            </div>
          </div>
        </>
      )}

      {/* Plaid Page */}
      {showPlaid && !showAgreement && (
        <>
          <div className="left-arrow-icon">
            <img
              src={BackIcon}
              alt="backIcon"
              className="back-icon"
              onClick={handleAgrrementBackButton}
            />
          </div>

          <div className="plaid-page-box">
            <div className="plaid-container">
              <div className="heading-text">
                <h4>Welcome</h4>
                <p>Link the first account that you’d like to use with Plaid</p>
              </div>
              <div className="plaid-btn" onClick={() => handlePlaidClick()}>
                <img src={PlaidLogo} alt="plaid logo" className="plaid-logo" />
                <p>Login securely with Plaid</p>

                <div className="btn-arrow-container">
                  <img
                    src={ButtonArrow}
                    alt="btn-arrow"
                    className="btn-arrow"
                  />
                </div>
              </div>

              <button
                className="cancel-plaid-button"
                onClick={handleAgrrementBackButton}
              >
                CANCEL
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GuestReport;
